module.exports = __webpack_public_path__ + "static/img/platinum.c0624304.png";